import {ReportModel} from "@fedeltapointofsale/data-client";
import {SalesByPaymentTypeReportData} from "./sales-by-payment-type-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class SalesByPaymentTypeReportModel extends ReportModel<SalesByPaymentTypeReportData> {
    constructor(injector: Injector) {
        super(injector, SalesByPaymentTypeReportData);
    }

}
